import * as React from 'react';

import { Box, Checkbox, Paper } from '@mui/material';
import CustomPaginationActionsTable from '../../../components/TablePagination';
import PaginateDataModel from '../../../Models/PaginateDataModel';

interface SWMSListProps {
  handlePagination: (data: any) => void;
  handleStatus: (data: any, type: string) => void;
  search?: any;
  recordList: any[];
  selectedRecords: any[];
  totalRecords: number;
  paginate: PaginateDataModel;
}
const SWMSList: React.FC<SWMSListProps> = ({
  handlePagination,
  handleStatus,
  recordList,
  selectedRecords,
  totalRecords,
  paginate,
}) => {
  const columns: any[] = [
    {
      field: 'id',
      headerName: 'Method',
      renderCell: (value: any, row: any) => (
        <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
          <Checkbox
            edge="start"
            checked={selectedRecords.includes(value)}
            tabIndex={-1}
            disableRipple
          />

          <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
            {row.method}
          </Box>
        </Box>
      ),
    },
    {
      field: 'hazards',
      headerName: 'Hazards',
    },
    {
      field: 'risks',
      headerName: 'Risk',
    },
    {
      field: 'controlMeasures',
      headerName: 'Control Measures',
    },
    {
      field: 'revisedRiskRating',
      headerName: 'Revised Risk Rating',
    },
    {
      field: 'responsiblePerson',
      headerName: 'Responsible Person',
    },
  ];
  return (
    <Paper sx={{ width: '100%' }} className="mt-4">
      <CustomPaginationActionsTable
        rows={recordList}
        columns={columns}
        totalRecords={totalRecords}
        handlePagination={(data: any) => {
          handlePagination(data);
        }}
        handleRowClick={(row: any) => {
          console.log('row-clicked');
          //   navigate('/data-management/labour/' + row.id);
          //console.log(data);
        }}
        paginationModel={{
          page: paginate.offset,
          pageSize: paginate.limit,
        }}
        handleStatus={(data: any) => {
          handleStatus(data, 'labour');
        }}
      />
    </Paper>
  );
};
export default SWMSList;
